import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'

import type { CampaignListRow } from 'models/campaigns-model'
import { getCampaignsReviewQuery } from 'models/campaigns-review-model'
import { get, patch } from 'utils/http'

// Campaigns awaiting review; rows used raw (snake_case, no derived values). Returns { items, count }.
export const useCampaignsReview = (meta: any) =>
  useQuery({
    queryKey: ['campaignsReview', meta],
    queryFn: async () => {
      const { campaigns, count } = await get<{ campaigns: CampaignListRow[]; count: number }>('/management/campaigns', {
        query: { ...getCampaignsReviewQuery(meta), status: 'review' },
      })
      return { items: campaigns || [], count }
    },
  })

// Cancel always refetches (parity with the old swallowing thunk).
export const useCancelCampaign = () => {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: async (campaignId: any) => {
      try {
        await patch(`/management/campaigns/${campaignId}/review/cancel`)
      } catch {
        /* swallowed for parity with the old createAPIAction */
      }
      queryClient.invalidateQueries({ queryKey: ['campaignsReview'] })
    },
  })
}
